import { cn } from '@shondalai/ui-commons';

interface DividerFieldProps {
  field: any;
}

export function DividerField({ field }: DividerFieldProps) {
  return (
    <hr
      className={cn("my-6", field.config.cssClass)}
      style={{ borderTop: '1px solid var(--ef-border, #E2E8F0)', opacity: 0.3 }}
    />
  );
}
